import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

import { GetUser, GetUserResponse } from '../../api/dtos/dtos';
import useGet from '../api/useGet';

const getData = (response?: SWRResponse<GetUserResponse, GetUserResponse>) => response?.data;
const getError = (response?: SWRResponse<GetUserResponse, GetUserResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetUser = (query?: Partial<GetUser>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }
        
        return () => {
            return new GetUser(query);
        }
    }, [query]);

    return useGet(request, { getData, getError }, configuration);
}